import React from 'react'
import {useTranslation} from 'react-i18next'

export default function HeadTable() {
  const {t} = useTranslation()

  const headTable = [
    {
      name: t('name'),
      class: 'min-w-150px',
    },
    {
      name: t('code'),
      class: 'min-w-150px',
    },
    {
      name: t('type'),
      class: 'min-w-150px',
    },
    {
      name: t('startDate'),
      class: 'min-w-150px px-2',
    },
    {
      name: t('endDate'),
      class: 'min-w-150px px-2',
    },
    {
      name: t('status'),
      class: 'min-w-150px px-2',
    },
    {
      name: t('action'),
      class: 'min-w-100px',
    },
  ]

  return (
    <thead>
      <tr className='fw-bold text-muted'>
        {headTable.map((e, i) => (
          <th
            style={{
              textAlign: i === 0 ? 'start' : 'start',
              width: i === headTable.length - 1 ? '108px' : 'auto',
            }}
            key={i}
            className={e.class}
          >
            {e.name}
          </th>
        ))}
      </tr>
    </thead>
  )
}
